
import PreEntryApi from '../../assets/js/preentry'
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Calendar from 'vux/src/components/calendar/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
Msg,
Divider,
XButton,
XHeader,
Flexbox,
FlexboxItem,
Group,
Cell,
XInput,
Search,
PopupRadio,
Calendar,
XTextarea,
Loading
},
data () {
return {
'id': '',
'to_train': '',
'career_planning': '',
'showLoading': true,
hasShowPopup: {
data: false
}
}
},
created () {
this.id = this.$route.query.id
PreEntryApi.getPlan({id: this.id}, (data, meta) => {
if (data) {
this.to_train = data.to_train
this.career_planning = data.career_planning
}
this.showLoading = false
}, (code, message) => {
this.showLoading = false
})
},
methods: {
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},
sendMaterial () {
if (!this.id) {
this.$message.error('非法操作。')
return false
}

if (!this.to_train || (this.to_train.length > 200)) {
this.$message.error('发展规划不能为空，字数不要超过200字。')
return false
}

if (!this.career_planning || (this.career_planning.length > 200)) {
this.$message.error('希望接受的培训不能为空，字数不要超过200字。')
return false
}


PreEntryApi.savePlan({
id: this.id,
to_train: this.to_train,
career_planning: this.career_planning
}, (data, meta) => {
if (data !== '') {
this.$message.error('资料信息更新失败。')
return false
}


this.$router.push({name: 'onboard.upload', query: {id: this.id}})
}, (code, message) => {
this.$message.error('资料信息更新失败。')

})
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/plan.vue